import React, {useEffect} from 'react';
import {HILIGHT_COLOR} from "../constants/constants";
import {Box, Tab, Tabs} from "@mui/material";
import {CreatedAppointmentsPage} from "./CreatedAppointmentsPage";
import {JoinedAppointmentsPage} from "./JoinedAppointmentsPage";
import {useFetchUserAppointments} from "../states/appointment/server";
import {useNavbar} from "../states/common/client";

export const MyPage: React.FC = () => {
    // states
    const [value, setValue] = React.useState(0);

    // hooks
    const { setNavbarTitle, setNavbarSettingsButton, setNavbarBackgroundColor, reset } = useNavbar()

    // queries
    const { data: userAppointments } = useFetchUserAppointments()

    const handleTabChange = (event: React.SyntheticEvent, selectTabIndex: number) => {
        setValue(selectTabIndex);
    };

    interface TabPanelProps {
        children?: React.ReactNode;
        index: number;
        value: number;
    }

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    function CustomTabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
            </div>
        );
    }

    useEffect(() => {
        reset()
        setNavbarTitle("마이페이지")
        setNavbarBackgroundColor(HILIGHT_COLOR)
        setNavbarSettingsButton(true)
    }, []);

    if (!userAppointments) {
        return <></>
    }

    return (
        <div className={"fullscreen"}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleTabChange} aria-label="mypage tabs" variant={"fullWidth"} indicatorColor={"primary"}>
                    <Tab label="내가 만든 약속" {...a11yProps(0)} />
                    <Tab label="참여한 약속" {...a11yProps(1)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <CreatedAppointmentsPage appointments={userAppointments.filter(item => item.role === 'ORGANIZER')} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <JoinedAppointmentsPage appointments={userAppointments.filter(item => item.role !== 'ORGANIZER')} />
            </CustomTabPanel>
        </div>
    )
}